module.exports = __webpack_public_path__ + "img/ResultsTypes_Municipal_&_Industrial_Demand.d4533fde.jpg";